export * from '@ifood/pomodoro-components';

import { ICONS as IFDL_ICONS, Icon as IfdlIcon, IconProps as IfdlIconProps } from '@ifood/design-language-icons';
import { defaultTheme as fitsTheme } from '@ifood/fits-themes';
import { WEB_THEME as ifoodPagoWebTheme } from '@ifood/pago-web-themes';

// Compoenents
export * from './src/components/organisms/Container';
export * from './src/components/organisms/GridContainer';
export * from './src/components/organisms/SidebarLayout';

export { IfdlIcon, IFDL_ICONS, type IfdlIconProps };

const ifoodPagoWebThemeCustom = {
  ...ifoodPagoWebTheme,
  ...fitsTheme,
  light: {
    ...ifoodPagoWebTheme.light,
    ...fitsTheme.light,
    breakpoint: {
      ...ifoodPagoWebTheme.light.breakpoint,
      ...fitsTheme.light.breakpoint,
    },
    sizing: {
      ...ifoodPagoWebTheme.light.sizing,
      ...fitsTheme.light.sizing,
    },
    spacing: {
      ...ifoodPagoWebTheme.light.spacing,
      ...fitsTheme.light.spacing,
    },
    component: {
      ...ifoodPagoWebTheme.light.component,
      ...fitsTheme.light.component,
    },
  },
  dark: {
    ...ifoodPagoWebTheme.dark,
    ...fitsTheme.dark,
    breakpoint: {
      ...ifoodPagoWebTheme.dark.breakpoint,
      ...fitsTheme.dark.breakpoint,
    },
    sizing: {
      ...ifoodPagoWebTheme.dark.sizing,
      ...fitsTheme.dark.sizing,
    },
    spacing: {
      ...ifoodPagoWebTheme.dark.spacing,
      ...fitsTheme.dark.spacing,
    },
    component: {
      ...ifoodPagoWebTheme.dark.component,
      ...fitsTheme.dark.component,
    },
  },
};

export const mainTheme = {
  ...ifoodPagoWebThemeCustom,
};
